module.exports = __webpack_public_path__ + "img/logo-name.14371640.png";